import { instance } from "libs/api";

import { AuditAlertResponse } from "../../auditLog.types";
import { ApiRoutesAuditLog } from "../../constants";

export const requestAcknowledgeAuditAlert = async (
  alertId: string
): Promise<AuditAlertResponse> => {
  return await instance.patch(
    `${ApiRoutesAuditLog.AuditAlerts}/${alertId}/${ApiRoutesAuditLog.Acknowledge}`
  );
};
